import {
  palette,
  createStyles,
  makeStyles,
  Theme,
} from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    stepper: {
      padding: 0,
    },
    stepConnector: {
      top: 14,
      left: 'calc(-50% + 14px)',
      right: 'calc(50% + 14px)',
      height: 2,
    },
    stepConnectorActive: {
      backgroundColor: theme.palette.primary.main,
      height: 2,
    },
    stepIconChecked: {
      stroke: theme.palette.primary.main,
      strokeWidth: 2,
    },
    stepIconCircle: {
      margin: '5px 0 3px',
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: theme.palette.divider,
    },
    stepIconCircleActive: {
      backgroundColor: theme.palette.primary.main,
    },
    stepIconError: {
      color: palette.error.main,
    },
    stepLabel: {
      '& .MuiStepLabel-alternativeLabel': {
        marginTop: 4,
        textAlign: 'center',
      },
      '& .MuiStepLabel-completed': {
        fontWeight: 'normal',
      },
    },
    stepLabelError: {
      '& .MuiStepLabel-alternativeLabel': {
        marginTop: 4,
        textAlign: 'center',
        color: theme.palette.grey['700'],
      },
    },
  })
);
